import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeftSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "#00427A",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.487 11.805L5.763 9.00195H14.52V7.00195L5.763 7.00195L8.487 4.19995L7.052 2.80495L2.002 8.00195L7.052 13.2L8.487 11.805Z"
	})]
});
const ForwardRef = forwardRef(SvgArrowLeftSmall);
export { ForwardRef as ReactComponent };
